module.exports = __webpack_public_path__ + "img/zhiyuanpinggu3.d8adeb09.png";